export default "__VITE_ASSET__BLS80sbC__"